import { render, staticRenderFns } from "./SupplementaryForm.vue?vue&type=template&id=bf4fdf44"
import script from "./SupplementaryForm.vue?vue&type=script&lang=js"
export * from "./SupplementaryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports